import { cn } from '@/utils/cn';
import React from 'react';

const ModalHeader = React.forwardRef<HTMLDivElement, React.ComponentProps<'div'>>(({ className, ...props }, ref) => {
  return <div ref={ref} className={cn('flex flex-col gap-[8px] pr-[40px] ', className)} {...props} />;
});
ModalHeader.displayName = 'ModalHeader';

const ModalTitle = React.forwardRef<HTMLDivElement, React.ComponentProps<'div'>>(({ className, ...props }, ref) => {
  return (
    <div
      ref={ref}
      data-modal-title
      className={cn('text-[16px] font-[700] leading-[21px] text-[#0C8DBF]  break-words whitespace-normal', className)}
      {...props}
    />
  );
});
ModalTitle.displayName = 'ModalTitle';

const ModalDescription = React.forwardRef<HTMLDivElement, React.ComponentProps<'div'>>(
  ({ className, ...props }, ref) => {
    return (
      <div
        ref={ref}
        data-modal-description
        className={cn('text-[12px] font-[400] leading-[20px] text-[#9D9D9C] break-words whitespace-normal ', className)}
        {...props}
      />
    );
  }
);
ModalDescription.displayName = 'ModalDescription';

export { ModalHeader, ModalTitle, ModalDescription };
